import getCookie from "@src/shared/utils/http/cookies";

const CSRF_TOKEN_KEY = "stitch-csrf-token";

/**
 * Get the current CSRF token from storage.
 */
export function getCsrfToken(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(CSRF_TOKEN_KEY);
}

/**
 * Set the CSRF token in storage.
 */
export function setCsrfToken(token: string): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(CSRF_TOKEN_KEY, token);
}

/**
 * Remove the CSRF token from storage.
 */
export function removeCsrfToken(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(CSRF_TOKEN_KEY);
}

/**
 * Look for a csrftoken cookie in the given fetch/XHR or redux-query server
 * response, and if found, set the current csrfToken.
 *
 * @return the token that was found in the response (if any).
 */
export function setCsrfFromResponse() {
  const token = getCookie("csrftoken");

  if (token) {
    setCsrfToken(token);
  }

  return token;
}
